/**
 *
 * Asynchronously loads the component for AdvisorMainHome
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AdvisorMainHome = lazyLoad(
  () => import('./index'),
  module => module.AdvisorMainHome,
);
